module.exports = __webpack_public_path__ + "static/media/tw.5a581d15.svg";